import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)
import fetch from '@/fetch'

export default new Factory(resource, {
  addon(payload = {}) {
    let { addon, state, reason } = payload

    const params = new URLSearchParams()
    if (reason) params.append('reason', reason)

    fetch(`/api/subscription/${state ? 'enable' : 'disable'}/${addon}?` + params.toString())
  },
})
